import { gql } from "@apollo/client"
import { useTranslation } from "react-i18next"
import type { CountryIntelligenceRulesRestrictiveCovenants } from "@oysterhr/schema"
import type { AdvisorKnowledgeBase } from "../../types"

export type Module = AdvisorKnowledgeBase<{
  restrictiveCovenants?: {
    postTermination: Pick<
      NonNullable<CountryIntelligenceRulesRestrictiveCovenants["postTermination"]>,
      "paymentRequired"
    >
  }
}>

export const queryFragment: Module["queryFragment"] = gql`
  fragment NonCompetitionPaymentRequired on CountryIntelligence {
    restrictiveCovenants {
      postTermination(nonCompetition: true) {
        paymentRequired
      }
    }
  }
`

export const TranslationComponent: Module["TranslationComponent"] = ({ data }) => {
  const paymentRequired = data.restrictiveCovenants?.postTermination?.paymentRequired
  const { t } = useTranslation("knowledge_base/Default")

  return (
    <>
      {t("restrictiveCovenants.generic")}
      <br />
      <br />
      {paymentRequired && t("restrictiveCovenants.paymentRequired")}
    </>
  )
}
